export default __webpack_public_path__ + "static/ggit-b3f022519d49bedb35464794b1243083.png";